import { useEffect } from "react";
import { Printer } from "lucide-react";
import { LogoMark } from "../components/site/Logo";
import { DISTRICTS, EMPLOYMENT_CATEGORIES, EXPERIENCE, GENDERS, MEMBERSHIP_CATEGORIES, ORG } from "../data/content";

const Line = ({ label }) => (
  <div className="flex items-end gap-3 py-2.5">
    <span className="w-56 shrink-0 text-[13px] font-semibold text-slate-800">{label}</span>
    <span className="flex-1 border-b border-slate-400" />
  </div>
);
const Choices = ({ label, options }) => (
  <div className="py-2.5">
    <p className="text-[13px] font-semibold text-slate-800">{label}</p>
    <div className="mt-1.5 flex flex-wrap gap-x-5 gap-y-1">{options.map((o) => <span key={o} className="flex items-center gap-1.5 text-xs text-slate-700"><span className="h-3 w-3 border border-slate-500" />{o}</span>)}</div>
  </div>
);

export default function MembershipFormPrint() {
  useEffect(() => { document.title = "Membership Application Form | IT Employees Federation"; }, []);
  return (
    <div className="min-h-screen bg-slate-200 py-8 print:bg-white print:py-0">
      <div className="no-print mx-auto mb-4 flex max-w-[820px] justify-end px-4">
        <button onClick={() => window.print()} className="btn-primary" data-testid="print-form-button"><Printer className="h-4 w-4" /> Print / Save as PDF</button>
      </div>
      <div className="mx-auto max-w-[820px] bg-white p-10 shadow print:shadow-none" data-testid="printable-membership-form">
        <div className="flex items-center justify-between border-b-4 border-navy pb-5">
          <div className="flex items-center gap-4">
            <LogoMark className="h-24 w-24" />
            <div>
              <p className="font-display text-xl font-extrabold text-navy">IT EMPLOYEES FEDERATION</p>
              <p className="text-[11px] font-semibold uppercase tracking-widest text-leaf">Standing strong for IT employees</p>
              <p className="text-[11px] text-slate-600">Affiliated to STU – Swatantra Thozhilali Union</p>
            </div>
          </div>
          <div className="flex h-32 w-24 items-center justify-center border border-slate-400 text-center text-[10px] text-slate-500">Affix passport size photo</div>
        </div>
        <h1 className="mt-6 text-center font-display text-lg font-bold tracking-wide text-navy">MEMBERSHIP APPLICATION FORM</h1>
        <div className="mt-4">
          <Line label="Full Name" /><Line label="Date of Birth" />
          <Choices label="Gender" options={GENDERS} />
          <Line label="Mobile Number" /><Line label="WhatsApp Number" /><Line label="Email Address" />
          <Line label="Residential Address" /><Line label="" /><Line label="District" />
          <Line label="Company / Employer Name" /><Line label="Designation" />
          <Choices label="Employment Category" options={EMPLOYMENT_CATEGORIES} />
          <Choices label="Years of Experience" options={EXPERIENCE} />
          <Choices label="Membership Category" options={MEMBERSHIP_CATEGORIES} />
          <Line label="ID Proof Type & Number" />
        </div>
        <div className="mt-6 border border-slate-400 p-4 text-xs leading-relaxed text-slate-700">
          <p className="font-bold">DECLARATION AND CONSENT</p>
          <p className="mt-1">I declare that the information provided above is true and correct to the best of my knowledge. I agree to abide by the rules and bye-laws of the IT Employees Federation, and I consent to the federation storing and using my personal information for membership purposes.</p>
          <div className="mt-8 flex justify-between"><span>Place & Date: ____________________</span><span>Signature of Applicant: ____________________</span></div>
        </div>
        <div className="mt-6 border border-dashed border-slate-400 p-4 text-xs text-slate-600">
          <p className="font-bold">FOR OFFICE USE ONLY</p>
          <div className="mt-4 flex justify-between"><span>Application No: __________</span><span>Membership No: __________</span><span>Approved by: __________</span></div>
        </div>
        <p className="mt-6 text-center text-[11px] text-slate-500">Submit the completed form with a copy of your ID proof at: {ORG.address} · {ORG.phoneDisplay} · {ORG.email}</p>
      </div>
    </div>
  );
}
